import React from 'react'
import { Alert } from 'react-bootstrap';
import Getter from '../database/Getter';
import './ProjectCardEdit.css';
/**
 * props:
name
year
category
challenge
excerpt
link
links
*/
class ProjectCardEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = { project: props.project, message: "" }
    }

    save(e) {
        e.preventDefault();
        this.setState({ message: '' }, () => {
            const project = this.state.project;
            Getter.updateToMySql(this.props.user, project, res => {
                if (res.id === project.id) {
                    this.setState({ message: "Success" });
                } else {
                    this.setState({ message: "Error" });
                }
            })
        })
    }

    delete(e) {
        e.preventDefault();
        this.setState({ message: '' }, () => {
            Getter.deleteToMySql(this.props.user, this.state.project.id, res => {
                if (res.id === this.state.project.id) {
                    this.setState({ message: "Success" });
                } else {
                    this.setState({ message: "Error" });
                }
            })
        })
    }

    change(e, field) {
        this.setState({ project: { ...this.state.project, [field]: e.target.value } })
    }

    render() {
        const {id} = this.state.project;
        return (
            <div className="prjedit">
                <form>
                    <div className="form-group">
                        <label htmlFor={`inputName${id}`}>Name:</label>
                        <input type="text" className="form-control" id={`inputName${id}`} value={this.state.project.name} onChange={e => this.change(e, "name")} />
                    </div>
                    <div className="form-group">
                        <span>Year: {this.state.project.year}</span>
                    </div>
                    <div className="form-group">
                        <span>Id: {this.state.project.id}</span>
                    </div>

                    <div className="form-group">
                        <label htmlFor={`inputPrize${id}`}>Prize:</label>
                        <input type="text" className="form-control" id={`inputPrize${id}`} value={this.state.project.prize} onChange={e => this.change(e, "prize")} />
                    </div>
                    <div className="form-group textarea">
                        <label htmlFor={`textareaContent1${id}`}>Content:</label>
                        <textarea className="form-control" id={`textareaContent1${id}`} rows="5" onChange={e => this.change(e, "content")} value={this.state.project.content}></textarea>
                    </div>
                    <div className="form-group textarea">
                        <label htmlFor={`textareaContent2${id}`}>Content Raw:</label>
                        <textarea className="form-control" id={`textareaContent2${id}`} rows="5" onChange={e => this.change(e, "content_raW")} value={this.state.project.content_raW}></textarea>
                    </div>
                    <div className="prjedit-submit">
                        <button type="button" className="btn btn-success" onClick={e => this.save(e)}>Save</button>
                        <button type="button" className="btn btn-danger" onClick={e => this.delete(e)}>Delete</button>
                        {this.state.message &&
                            <Alert className="alert" variant='primary'>
                                {this.state.message}
                            </Alert>
                        }
                    </div>
                </form>
            </div>
        )
    }

}

export default ProjectCardEdit